import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './../services/loader.service'; // Adjust path if needed
import { inject } from '@angular/core';

export const loaderInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  // Inject the LoaderService using inject() since we don't have a constructor
  const loaderService = inject(LoaderService);

  const bodyNoLoader =
    request.body !== null &&
    typeof request.body === 'object' &&
    !Array.isArray(request.body) &&
    ('noLoader' in (request.body as object) && !!(request.body as Record<string, unknown>)['noLoader']
      || '$pageSize' in (request.body as object) && !!(request.body as Record<string, unknown>)['$pageSize']
      || '$pageNumber' in (request.body as object) && !!(request.body as Record<string, unknown>)['$pageNumber']
    );

  const noLoader = !!request.params.get('noLoader') || bodyNoLoader;
  if (!noLoader) {
    loaderService.showLoader(); // Show loader before request
  }

  return next(request).pipe(
    finalize(() => {
      if (!noLoader) {
        loaderService.hideLoader(); // Hide loader after request completes
      }
    })
  );
};
